export function inputReducer(state, action) {
  switch (action.type) {
    case action.type:
      state[action.type] = action.payload;
      return Object.assign({}, state);
    default:
      return Object.assign({}, state);
  }
}
